import React from 'react';
import { motion } from "motion/react";
import { LoginForm } from './LoginForm';

export const LoginHero: React.FC = () => {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <motion.main 
      className="pt-16 pb-8"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="min-h-[calc(100vh-6rem)] flex items-center justify-center px-8 pt-7">
        <div className="w-full max-w-md">
          
          {/* Header Section */}
          <motion.div 
            className="text-center mb-8"
            variants={itemVariants}
          >
            <motion.h1 
              className="text-3xl lg:text-4xl font-serif font-medium text-white mb-3 tracking-tight"
              variants={itemVariants}
            >
              Welcome Back
            </motion.h1>
            <motion.p 
              className="text-gray-400 leading-relaxed"
              variants={itemVariants}
            >
              Sign in to your account to continue.
            </motion.p>
          </motion.div>

          {/* Login Form */}
          <motion.div variants={itemVariants}>
            <LoginForm />
          </motion.div>
        </div>
      </div>
    </motion.main>
  );
};
